import axios,
{
  // AxiosHeaders
} from "axios";
//TODO
// import Cookies from "js-cookie";

const apiInstance = axios.create({
  baseURL: import.meta.env.VITE_ADMIN_HOST,
  headers: {
    "Content-Type": "application/json"
  }
});

apiInstance.interceptors.request.use(
  config => {
    //TODO
    // const token = Cookies.get("jwt");
    // if (token) {
    //   config.headers["X-Auth-Token"] = token;
    // }
    if (config.headers["Content-Type"] === "application/pdf") {
      config.headers.Accept = "application/pdf";
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);
apiInstance.interceptors.response.use(
  response => {
    //TODO
    // if (
    //   response.headers instanceof AxiosHeaders &&
    //   response.headers.has("x-auth-token")
    // ) {
    //   Cookies.set("jwt", response.headers["x-auth-token"]);
    // }
    return response;
  },
  error => {
    return Promise.reject(error);
  }
);

export { apiInstance };
